<template>
  <div class="accepted-brands">
    <SvgImage
      v-for="brand in brands"
      class="accepted-brands__image"
      :icon="brand"
      width="30"
      height="30"
    />
  </div>
</template>

<script>
import SvgImage from '~/components/General/SvgImage.vue';

export default {
  name: 'AcceptedBrands',
  components: {
    SvgImage,
  },
  setup() {
    const brands = ['visa', 'mastercard', 'elo', 'hipercard'];

    return {
      brands,
    };
  },

};
</script>

<style lang="scss">
@import "assets/themes/_variables.scss";

.accepted-brands {
    display: flex;
    justify-content: center;
    gap: 1rem;
}

</style>
